import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Home } from "lucide-react";
import { useLang } from "../contexts/LanguageContext";

/**
 * Persistent back-navigation bar shown at the top of any sub-page.
 * - "Retour" / "Back" → browser history previous (or fallback link)
 * - "Tableau de bord" / "Dashboard" → fixed dashboard link
 */
export function BackBar({ to = "/", fallbackLabelFr = "Accueil", fallbackLabelEn = "Home" }) {
  const { lang } = useLang();
  const nav = useNavigate();

  const goBack = () => {
    if (window.history.length > 1) nav(-1);
    else nav(to);
  };

  return (
    <div className="flex items-center justify-between gap-3 mb-6" data-testid="back-bar">
      <button
        onClick={goBack}
        data-testid="back-btn"
        className="inline-flex items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
        {lang === "fr" ? "Retour" : "Back"}
      </button>
      <Link
        to={to}
        data-testid="home-btn"
        className="inline-flex items-center gap-1.5 text-sm text-primary hover:text-primary/80 font-medium transition-colors"
      >
        <Home className="w-4 h-4" />
        {lang === "fr" ? fallbackLabelFr : fallbackLabelEn}
      </Link>
    </div>
  );
}
